import { get, patch, post } from "../../utils/request";

export const getUser = async (name, token) => {
  const res = await get(`users?name=${name}&token=${token}`);
  return res;
};

export const getUserByToken = async (token) => {
  const res = await get(`users?token=${token}`);
  return res;
};

export const patchUserLike = async (id, liked) => {
  const res = await patch(`users/${id}`, { liked });
  return res;
};

export const getProductsByShop = async (name_shop) => {
  const res = await get(`products?name_shop=${name_shop}`);
  return res;
};

export const postOffer = async (data) => {
  const res = await post(`offers`, data);
  return res;
};

export const getOffersByShop = async (shopOwner) => {
  return await get(`offers?shopOwner=${shopOwner}`);
};

export const getOffersByUser = async (username) => {
  return await get(`offers?username=${username}`);
};

export const updateOffer = async (id, data) => {
  return await patch(`offers/${id}`, data);
};

export const patchUserCart = async (id, cart) => {
  return patch(`users/${id}`, { cart });
};
